export default "__VITE_ASSET__D2ShZp1m__"